import { addWithConfig } from '../../utils';
import { Text } from '../text';

import type { HeaderProps } from './types';

export const Header = (props: HeaderProps) => <Text variant="headerOne" {...props} />;

export default addWithConfig(Header);
